export default __webpack_public_path__ + "static/media/photo--lg--kara8.e3c291c1.jpg";